import {FunctionComponent} from 'react';

type UserAvatarImageProps = {
  avatarUrl: string;
  displayName: string;
  widthClassName: `w-${string}`;
  whiteBorder?: boolean;
};
export const UserAvatarImage: FunctionComponent<UserAvatarImageProps> = ({
  avatarUrl,
  displayName,
  widthClassName,
  whiteBorder = true,
}) => {
  const whiteBorderClassName = whiteBorder ? 'border-4 border-white' : '';

  return (
    <img
      src={avatarUrl}
      alt={`${displayName} avatar`}
      className={`${widthClassName} ${whiteBorderClassName} inline object-cover aspect-square rounded-full`}
    />
  );
};
